import { X, ChevronRight, ChevronDown, Users, Home, Phone, Newspaper, Image, PlusCircle, Plus, Minus, Smartphone } from "lucide-react";
import { Link } from "react-router-dom"
import React, { useEffect, useState } from "react"
import { motion, AnimatePresence } from "framer-motion";
// import son from '../Header/logo.png'


import { auth } from '../../firebase';
import { onAuthStateChanged } from 'firebase/auth';

export default function Sidebar({ setOpenSidebar, openSidebar }) {
    const [user, setUser] = useState(null);
    const [hoverA, setHovA] = useState(false)
    const [eventsOpen, setEventsOpen] = useState(false)
    const [mediaOpen, setMediaOpen] = useState(false)
    const [moreOpen, setMoreOpen] = useState(false)

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
                if (currentUser) {
                    setUser(currentUser);
                } else {
                    setUser(null);
                }
        });

        return () => unsubscribe();
    }, []);

    const EventData = [
        { name: "Main Events", link: "/Events" },
        { name: "Standard Yearly Events", link: "/YearlyEvents" },
        { name: "Upcoming Events", link: "/UpcomingEvents" },
        { name: "Past Events", link: "/PastEvents" }
    ];

    const About = [
        { name: "About Us", link: "/About" },
        { name: "Leader Olumba Olumba Obu", link: "/Leader" },
        { name: "His Holiness Olumba Olumba Obu", link: "/His" },
        { name: "Doctrine", link: "/Doctrine" },
        { name: "Sacrament", link: "/Sacrament" },
    ];

    const Establishment = [
        { name: "Mother Elizabeth Redeemed Home", link: "/Redeem" },
        { name: "BookShop", link: "/BookShop" },
        { name: "Pool Of Life", link: "/Pool" },
        { name: "Royal Museum", link: "/Museum" },
    ];

    const Media = [
        { name: "StarCross", link: "/STV" },
        { name: "New Kingdom Trumpet", link: "/NKT" },
        { name: "Everlasting Gospel", link: "/EGC" },
        { name: "BCS ICT", link: "/ICT" },
    ];

    return (
        <AnimatePresence>
            {openSidebar && (
                <>
                    {/* Backdrop Blur */}
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        onClick={() => setOpenSidebar(false)}
                        className="fixed inset-0 bg-stone-900/40 backdrop-blur-sm z-[65]"
                    />

                    {/* Sidebar */}
                    <motion.nav
                        initial={{ x: '100%' }}
                        animate={{ x: 0 }}
                        exit={{ x: '100%' }}
                        transition={{ type: "spring", damping: 25, stiffness: 200 }}
                        className="fixed top-0 right-0 bottom-0 w-80 md:w-96 bg-stone-900/10 backdrop-blur-2xl border-l border-white/10 p-8 overflow-y-auto z-[70] shadow-2xl"
                    >
                        <div className="flex justify-between items-center mb-12">
                            <img src={'/bcs.png'} alt="BCS Logo" className="h-16 w-auto opacity-90" />
                            <button
                                onClick={() => setOpenSidebar(false)}
                                className="p-2 hover:bg-white/5 rounded-full transition-colors"
                            >
                                <X className="text-white text-3xl" />
                            </button>
                        </div>

                        <div className="space-y-8">
                            {/* PRIMARY LINKS */}
                            <div className="space-y-1">
                                <Link to="/" onClick={() => setOpenSidebar(false)} className="flex items-center gap-4 text-white hover:text-blue-400 py-3 px-4 rounded-xl hover:bg-white/5 transition-all font-semibold text-xs tracking-[0.2em] uppercase">
                                    <Home size={18} /> Home
                                </Link>

                                {/* DROPDOWNS */}
                                <div className="space-y-1">
                                    {/* About Dropdown */}
                                    <button
                                        onClick={() => setHovA(!hoverA)}
                                        className="w-full flex items-center justify-between text-white hover:text-blue-400 py-3 px-4 rounded-xl hover:bg-white/5 transition-all font-semibold text-xs tracking-[0.2em] uppercase"
                                    >
                                        <span className="flex items-center gap-4">
                                            {hoverA ? <Minus size={14} /> : <Plus size={14} />} About
                                        </span>
                                        <ChevronRight size={18} className={`transition-transform duration-300 ${hoverA ? 'rotate-90' : ''}`} />
                                    </button>
                                    {hoverA && (
                                        <motion.div initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }} className="ml-8 space-y-1 border-l border-white/10">
                                            {About.map((item, idx) => (
                                                <Link key={idx} to={item.link} onClick={() => setOpenSidebar(false)} className="block py-2 px-4 text-[11px] text-white/80 hover:text-blue-400 transition-colors lowercase font-sans tracking-widest">
                                                    {item.name}
                                                </Link>
                                            ))}
                                        </motion.div>
                                    )}

                                    {/* Events Dropdown */}
                                    <button
                                        onClick={() => setEventsOpen(!eventsOpen)}
                                        className="w-full flex items-center justify-between text-white hover:text-blue-400 py-3 px-4 rounded-xl hover:bg-white/5 transition-all font-semibold text-xs tracking-[0.2em] uppercase"
                                    >
                                        <span className="flex items-center gap-4">
                                            {eventsOpen ? <Minus size={14} /> : <Plus size={14} />} Events
                                        </span>
                                        <ChevronRight size={18} className={`transition-transform duration-300 ${eventsOpen ? 'rotate-90' : ''}`} />
                                    </button>
                                    {eventsOpen && (
                                        <motion.div initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }} className="ml-8 space-y-1 border-l border-white/10">
                                            {EventData.map((item, idx) => (
                                                <Link key={idx} to={item.link} onClick={() => setOpenSidebar(false)} className="block py-2 px-4 text-[11px] text-white/80 hover:text-blue-400 transition-colors lowercase font-sans tracking-widest">
                                                    {item.name}
                                                </Link>
                                            ))}
                                        </motion.div>
                                    )}
                                </div>

                                <Link to="/Contact" onClick={() => setOpenSidebar(false)} className="flex items-center gap-4 text-white hover:text-blue-400 py-3 px-4 rounded-xl hover:bg-white/5 transition-all font-semibold text-xs tracking-[0.2em] uppercase">
                                    <Phone size={18} /> Contact Us
                                </Link>

                                <Link to="/EGC" onClick={() => setOpenSidebar(false)} className="flex items-center gap-4 text-white hover:text-blue-400 py-3 px-4 rounded-xl hover:bg-white/5 transition-all font-semibold text-xs tracking-[0.2em] uppercase">
                                    <Newspaper size={18} /> Sermon
                                </Link>

                                <Link to="/Gallery" onClick={() => setOpenSidebar(false)} className="flex items-center gap-4 text-white hover:text-blue-400 py-3 px-4 rounded-xl hover:bg-white/5 transition-all font-semibold text-xs tracking-[0.2em] uppercase">
                                    <Image size={18} /> Gallery
                                </Link>

                                {user && user.email === 'asuquo@ooocs.org' && (
                                    <Link to="/post" onClick={() => setOpenSidebar(false)} className="flex items-center gap-4 text-white hover:text-blue-400 py-3 px-4 rounded-xl hover:bg-white/5 transition-all font-semibold text-xs tracking-[0.2em] uppercase">
                                        <PlusCircle size={18} /> Create
                                    </Link>
                                )}
                            </div>

                            {/* SECONDARY SECTIONS */}
                            <div className="pt-8 space-y-4">
                                <div className="px-4">
                                    <h4 className="text-[10px] tracking-[0.3em] text-white/50 uppercase font-black mb-4">Experience</h4>

                                    {/* Media Section */}
                                    <div className="mb-4">
                                        <button
                                            onClick={() => setMediaOpen(!mediaOpen)}
                                            className="w-full flex items-center justify-between text-white hover:text-blue-400 py-2 transition-colors font-semibold text-[10px] tracking-widest uppercase"
                                        >
                                            Media {mediaOpen ? <ChevronDown size={14} /> : <ChevronRight size={14} />}
                                        </button>
                                        {mediaOpen && (
                                            <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="mt-2 space-y-2 pl-4">
                                                {Media.map((item, idx) => (
                                                    <Link key={idx} to={item.link} onClick={() => setOpenSidebar(false)} className="block py-1 text-[11px] text-white/80 hover:text-blue-400 transition-colors">
                                                        {item.name}
                                                    </Link>
                                                ))}
                                            </motion.div>
                                        )}
                                    </div>

                                    {/* Establishments Section */}
                                    <div>
                                        <button
                                            onClick={() => setMoreOpen(!moreOpen)}
                                            className="w-full flex items-center justify-between text-white hover:text-blue-400 py-2 transition-colors font-semibold text-[10px] tracking-widest uppercase"
                                        >
                                            Establishments {moreOpen ? <ChevronDown size={14} /> : <ChevronRight size={14} />}
                                        </button>
                                        {moreOpen && (
                                            <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="mt-2 space-y-2 pl-4">
                                                {Establishment.map((item, idx) => (
                                                    <Link key={idx} to={item.link} onClick={() => setOpenSidebar(false)} className="block py-1 text-[11px] text-white/80 hover:text-blue-400 transition-colors">
                                                        {item.name}
                                                    </Link>
                                                ))}
                                            </motion.div>
                                        )}
                                    </div>
                                </div>

                                {/* FOOTER LINKS */}
                                <div className="px-4 pt-12">
                                    <Link to="/Blog" onClick={() => setOpenSidebar(false)} className="flex items-center gap-4 text-white/80 hover:text-blue-400 transition-colors text-[10px] tracking-[0.2em] uppercase mb-4 font-semibold">
                                        <Newspaper size={14} /> Blog
                                    </Link>
                                    <Link to="/Apps" onClick={() => setOpenSidebar(false)} className="flex items-center gap-4 text-white/80 hover:text-blue-400 transition-colors text-[10px] tracking-[0.2em] uppercase mb-4 font-semibold">
                                        <Smartphone size={14} /> Mobile Apps
                                    </Link>
                                    <a href="https://www.uabcsp.org" target="_blank" rel="noopener noreferrer" className="flex items-center gap-4 text-white/80 hover:text-blue-400 transition-colors text-[10px] tracking-[0.2em] uppercase font-semibold">
                                        <Users size={14} /> UABCSP
                                    </a>
                                </div>
                            </div>
                        </div>
                    </motion.nav>
                </>
            )}
        </AnimatePresence>
    );
}